import { render, staticRenderFns } from "./CtaBox.vue?vue&type=template&id=1c6f735a&"
import script from "./CtaBox.vue?vue&type=script&lang=js&"
export * from "./CtaBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports